export default "__VITE_ASSET__DNDHocQf__"